import {useEffect, useState} from "react";
import {currentHoliday, currentHolidayLong, isHolidayFocus} from "../../models/variableCopywriting";
import "../../assets/styles/popupBanner.css"


export default function FullPagePopupBanner() {

    const [shouldShow, setShouldShow] = useState(false);

    useEffect(() => {
        setTimeout(() => setShouldShow(true), 30000);  // Present after 30 seconds
    }, [])

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // This will trigger when user clicks the X, refreshes, or navigates away
            event.preventDefault();
            event.returnValue = ''; // Shows browser's generic warning
            // Your custom logic (e.g., send analytics)
            console.log('User is leaving (including tab close)');
            setShouldShow(true);
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, []);


    const containerStyle = {
        display: 'grid',  // flex
        gridTemplateColumns: '1fr 1fr', // Two equal-width columns
        gap: '20px', // Space between columns

        flexWrap: "wrap",
        rowGap: '16px',
        columnGap: "2%",

        width: '100%',
        // maxWidth: '457px',
        marginTop: '16px',
        justifyContent: 'space-between',
    };

    return (
        <div>
            {
                shouldShow &&
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75" style={{zIndex: 9999999999}}>{/* Click handler to close the modal when clicking outside of it */}
                    <div className="absolute inset-0" onClick={() => setShouldShow(false)}></div>
                    <div id="lightbox" className="lightbox rounded-xl">
                        <div className="container">
                            <div id="close-lightbox" className="lightbox--close"
                                 onClick={() => setShouldShow(!shouldShow)}>
                                <span>Close</span>
                                <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M8.49994 10.4211L15.6578 18L16.9999 16.579L9.84203 9.00008L17 1.42104L15.6579 0L8.49994 7.57903L1.34209 0.000135521L0 1.42118L7.15784 9.00008L0.000143351 16.5788L1.34224 17.9999L8.49994 10.4211Z"
                                        fill="#0B1836"/>
                                </svg>
                            </div>
                            <div className="content" style={{gap: "0px"}}>
                                <h2 className="" style={{textTransform: "uppercase"}}>
                                    <span style={{fontWeight: 700, marginTop: 0, marginBottom: 0}} className="custom-font ">
                                        Attention<div className="" style={{color: "red"}}>Retailers</div>
                                    </span>
                                </h2>
                                <p>
                                    <span className="custom-font " style={{fontWeight: 400, marginTop: 0, marginBottom: 0}}>
                                        {
                                            isHolidayFocus && <span>{currentHolidayLong} is the biggest opportunity you have at multiplying your revenue. </span>
                                        }
                                        Never let a weak SEO setup be the bottleneck!
                                    </span>
                                </p>
                                <div style={{marginTop: 4}}>

                                    <div className="" style={containerStyle}>
                                        <div>
                                            <a className="popupButton"
                                               href="/checkout?index=launch"
                                               target="_blank"><div className="">Launch&nbsp;Pad</div></a>
                                        </div>
                                        <div>
                                            <a className="popupButton"
                                               href="/checkout?index=growth"
                                               target="_blank">Growth</a>
                                        </div>
                                        <div>
                                            <a className="popupButton"
                                               href="/checkout?index=market-leader"
                                               target="_blank">Market&nbsp;Leader</a>
                                        </div>
                                        <div>

                                            <a className="popupButton"
                                               href="/seo-retainer"
                                               target="_blank">See All</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <figure className="picture">
                                <img alt=""
                                     src="https://images.pexels.com/photos/6347515/pexels-photo-6347515.jpeg"/>
                            </figure>
                        </div>
                    </div>
                </div>
            }
        </div>
    )

}